import { render, staticRenderFns } from "./PackageUploadSettings.vue?vue&type=template&id=71a070f5&"
import script from "./PackageUploadSettings.vue?vue&type=script&lang=js&"
export * from "./PackageUploadSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports